import React, { Component } from 'react';

import ContactUs from '../../components/ContactUs';

export default class ContactPage extends Component {
  render() {
    return <ContactUs />;
  }
}
